import { createFileRoute, Outlet } from '@tanstack/react-router';

import { i18n } from '../../i18n';

export const Route = createFileRoute('/permissions')({
  staticData: {
    permissionSection: 'settings',
    section: 'Settings',
    breadcrumb: () => i18n.t('terms.permissions', { ns: 'common' }),
    layout: 'full-height',
  },
  component: () => <Outlet />,
});
